export {
  MatDialogRef as DialogRef,
  MAT_DIALOG_DATA as DIALOG_DATA
} from '@angular/material';
import { IPromptConfig } from '@covalent/core';

export interface PromptConfig extends IPromptConfig {
  maxLength?: number;
}
